'use client';

import { highEmphasis, mediumEmphasis, lowEmphasis } from "../Button.css.js";
function getCssVariant(p) {
  if (p.emphasis === "high") return highEmphasis[p.variant];
  if (p.emphasis === "medium") return mediumEmphasis[p.variant];
  return lowEmphasis[p.variant];
}
export {
  getCssVariant
};
